module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqBAMAAAA37dRoAAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABXRSTlMAQCWVb7bC2BEAAABJSURBVCjPY6AmUMImyBxqgEVUNTQIi6hoaODIFmUSBAPX0BAIQwEsahqKCoLBSkPRgQJOUUwTsNs2aMJhEIkCUyrhVI3IAVQEAFq6LsGovgCAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_follow.png
// module id = 353
// module chunks = 0 1 2 3 4